import { NUMBER_VARIANTS_ANIMATION, ID_PREFIX_ANIMATION, CHANCE_OF_ANIMATION } from './FrameSvgConstants'

export const animationStyleForTrait = (animationTrait = 0) => {
  return animationTrait <= CHANCE_OF_ANIMATION
    ? ID_PREFIX_ANIMATION.concat(animationTrait % NUMBER_VARIANTS_ANIMATION)
    : null
}
